
import md5 from 'blueimp-md5/js/md5.min.js'
import 'pages/auth.tag'
import 'pages/orders/orders.tag'
import 'pages/products/products.tag'
import 'pages/sections/sections.tag'
import 'pages/persons/persons.tag'
import 'pages/comments/comments.tag'
import 'pages/news/news.tag'
import 'pages/user-reviews.tag'
import 'pages/images/images-manager.tag'
import 'pages/images/images.tag'
import 'pages/settings/settings.tag'
import 'pages/payments/payments.tag'
import 'pages/analytics/analytics.tag'
import 'pages/not-found.tag'
import 'pages/settings/add-fields/add-fields-edit-block.tag'
import parallel from 'async/parallel'
import 'pages/purchases/purchases.tag'
import 'components/order-person-search.tag'
import 'components/current-time.tag'

riot.tag2('app', '  <div if="{unsupported}">\n    <div class="old-browser">\n      <div class="old-browser__content">\n        <p>Для работы с сайтом необходим современный браузер.</p>\n        <p>Загрузите и установите один из этих браузеров:</p>\n      </div>\n      <div class="old-browser__browsers"><a class="old-browser__browser-link firefox" href="http://www.mozilla-europe.org/" target="_blank">Firefox</a><a class="old-browser__browser-link chrome" href="http://www.google.com/chrome/" target="_blank">Chrome</a><a class="old-browser__browser-link opera" href="http://www.opera.com/" target="_blank">Opera</a></div>\n    </div>\n  </div>\n  <loader if="{loader}" size="large" text="Загрузка"></loader>\n  <auth if="{!app.auth &amp;&amp; !loader}"></auth>\n  <images-manager if="{imageLoad &amp;&amp; !loader}"></images-manager>\n  <div class="app-layout" if="{sidebarShow}" onclick="{toggleSidebar}"></div>\n  <div class="wrapper" if="{!unsupported &amp;&amp; app.auth &amp;&amp; !loader &amp;&amp; !imageLoad}">\n    <div class="sidebar-left {active: sidebarShow}">\n      <div class="logo"></div>\n      <div class="menu">\n        <div class="menu__up" onclick="{scrollMenuTop}" style="display: none;"></div>\n        <div class="menu__down" onclick="{scrollMenuBottom}"></div>\n        <ul onscroll="{onResize}">\n          <li class="menu-item {active: name == tab}" each="{sidebar}" if="{checkPermission(permission, 1000)}"><a href="#{link}"><i class="fa {icon}"></i><span>{title}</span><span class="notice-count notice-count-{name}" if="{notice}">0</span></a></li>\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n          <li class="hidden-md hidden-sm hidden-lg"><a href="{app.config.projectURL}" target="_blank" title="Перейти на сайт"><i class="fa fa-share"></i><span>Перейти на сайт</span></a></li>\n          <li class="hidden-md hidden-sm hidden-lg"><a onclick="{logout}" href="#"><i class="fa fa-sign-out"></i><span>Выход</span></a></li>\n        </ul>\n      </div>\n    </div>\n    <div class="main-container">\n      <div class="navbar navbar-default navbar-fixed-top m-b-2">\n        <div class="container-fluid">\n          <div class="navbar-header">\n            <button class="navbar-toggle pull-left m-x-2" onclick="{toggleSidebar}" type="button"><span class="sr-only"></span><span class="icon-bar"></span><span class="icon-bar"></span><span class="icon-bar"></span></button><a class="navbar-brand">{headTitle || \'Shop 24\'}</a>\n          </div>\n          <div class="navbar-collapse collapse">\n            <current-time></current-time>\n            <ul class="nav navbar-nav navbar-right">\n              <li if="{app.config.projectURL}"><a href="{app.config.projectURL}" target="_blank" title="Перейти на сайт"><i class="fa fa-share"></i></a></li>\n              <li><a onclick="{logout}" href="#"><i class="fa fa-fw fa-sign-out"></i>Выход</a></li>\n            </ul>\n            <order-person-search></order-person-search>\n          </div>\n        </div>\n      </div>\n      <div class="main col-md-12" style="width: 100%;">\n        <desktop if="{tab == &quot;desktop&quot;}">\n          <h4>Рабочий стол - в разработке</h4>\n        </desktop>\n        <orders if="{tab == &quot;orders&quot;}"></orders>\n        <purchases if="{tab == &quot;purchases&quot;}"></purchases>\n        <products if="{tab == &quot;products&quot;}"></products>\n        <payments if="{tab == &quot;payments&quot;}"></payments>\n        <persons if="{tab == &quot;persons&quot;}"></persons>\n        <news if="{tab == &quot;news&quot;}"></news>\n        <user-reviews if="{tab == &quot;reviews&quot;}"></user-reviews>\n        <images if="{tab == &quot;images&quot;}"></images>\n        <sections if="{tab == &quot;sections&quot;}"></sections>\n        <analytics if="{tab == &quot;analytics&quot;}"></analytics>\n        <settings if="{tab == &quot;settings&quot;}"></settings>\n        <not-found if="{tab == &quot;not-found&quot;}"></not-found>\n      </div>\n    </div>\n  </div>\n', 'app .app-layout,[riot-tag="app"] .app-layout,[data-is="app"] .app-layout{ position: fixed; top: 0; left: 0; right: 0; bottom: 0; background-color: #000; opacity: 0.7; z-index: 1100; } app .menu-item,[riot-tag="app"] .menu-item,[data-is="app"] .menu-item{ position: relative; } app .notice-count,[riot-tag="app"] .notice-count,[data-is="app"] .notice-count{ background: #d9534f; position: absolute; right: 0; top: 0; min-width: 16px; height: 16px; font-size: 11px; padding: 2px; white-space: nowrap; text-align: center; color: #fff; }', '', function(opts) {
'use strict';

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var self = this;

self.app = app;
self.mixin('permissions');
self.auth = false;
self.sidebarShow = false;
self.loader = true;
self.auth = app.auth;
self.imageLoad = false;

var route = riot.route.create();

route(function (tab) {
    if (tab == '') {
        if (self.checkPermission(self.sidebar[1].permission, "1000")) {
            riot.route(self.sidebar[1].link);
        } else {
            var links = self.sidebar.filter(function (i) {
                return self.checkPermission(i.permission, "1000");
            });
            if (links.length) {
                riot.route(links[0].link);
            } else {
                riot.route('');
                observable.trigger('not-found');
            }
        }
    } else {
        if (tab == 'imageLoad') {
            self.imageLoad = true;
            self.update();
            return;
        }
        var idx = self.sidebar.map(function (item) {
            return item.name;
        }).indexOf(tab);
        if (idx !== -1 && self.checkPermission(self.sidebar[idx].permission, 1000)) {
            var item = self.sidebar.filter(function (item) {
                return item.name === tab;
            });
            self.headTitle = item[0].title;
            self.tab = tab;
        } else {
            observable.trigger('not-found');
        }
    }
    self.sidebarShow = false;
    document.body.classList.remove('modal-open');
    window.scrollTo(0, 0);
    self.update();
});

self.unsupported = app.checkUnsupported();

self.sidebar = [{ title: 'Аналитика', name: 'analytics', link: 'analytics', permission: '', icon: 'fa-area-chart ' }, { title: 'Заказы', name: 'orders', link: 'orders', permission: 'orders', icon: 'fa-shopping-cart', notice: true }, { title: 'Закупки', name: 'purchases', link: 'purchases', permission: 'purchases', icon: 'fa-shopping-basket' }, { title: 'Товары', name: 'products', link: 'products', permission: 'products', icon: 'fa-shopping-bag' }, { title: 'Платежи', name: 'payments', link: 'payments', permission: 'payments', icon: 'fa-money' }, { title: 'Контакты', name: 'persons', link: 'persons', permission: 'contacts', icon: 'fa-users' }, { title: 'Публикации', name: 'news', link: 'news', permission: 'news', icon: 'fa-newspaper-o' }, { title: 'Отзывы', name: 'reviews', link: 'reviews', permission: 'reviews', icon: 'fa-comment-o' }, { title: 'Разделы', name: 'sections', link: 'sections', permission: 'sections', icon: 'fa-file-text' }, { title: 'Картинки', name: 'images', link: 'images/products', permission: 'images', icon: 'fa-picture-o' }, { title: 'Настройки', name: 'settings', link: 'settings', permission: 'settings', icon: 'fa-cogs' }];

self.toggleSidebar = function () {
    self.sidebarShow = !self.sidebarShow;
    if (self.sidebarShow) document.body.classList.add('modal-open');else document.body.classList.remove('modal-open');
};

self.logout = function () {
    localStorage.removeItem('shop24');
    localStorage.removeItem('shop24_permissions');
    localStorage.removeItem('shop24_cookie');
    localStorage.removeItem('shop24_user');
    localStorage.removeItem('shop24_main_user');
    window.location.reload();
};

self.getActiveAccount = function () {
    var shop = JSON.parse(localStorage.getItem('shop24') || '{}');
    if ('login' in shop) {
        (function () {
            var login = shop.login;

            var item = app.accounts.filter(function (item) {
                return item.login === login;
            })[0] || {};
            if ('login' in item) self.activeLogin = item.login;
        })();
    }
};

observable.on('auth', function (auth) {
    if (auth) self.getActiveAccount();
    self.loader = false;
    self.update();
});

observable.on('not-found', function () {
    self.headTitle = '404';
    self.tab = 'not-found';
    self.update();
});

self.onResize = function (e) {
    var menuWrapper = self.root.querySelector('.menu');
    var menuUp = menuWrapper.querySelector('.menu__up');
    var menuDown = menuWrapper.querySelector('.menu__down');
    var menu = menuWrapper.querySelector('ul');

    if (menu.scrollTopMax === 0) {
        menuUp.style.display = 'none';
        menuDown.style.display = 'none';
    } else {
        if (menu.scrollTop === 0) {
            menuUp.style.display = 'none';
            menuDown.style.display = 'block';
        }

        if (menu.scrollTop === menu.scrollTopMax) {
            menuUp.style.display = 'block';
            menuDown.style.display = 'none';
        }

        if (menu.scrollTop !== 0 && menu.scrollTop !== menu.scrollTopMax) {
            menuUp.style.display = 'block';
            menuDown.style.display = 'block';
        }
    }
};

self.scrollMenuTop = function (e) {
    $(self.root).find('.menu ul').animate({ scrollTop: 0 }, '300');
};

self.scrollMenuBottom = function (e) {
    var menu = $(self.root).find('.menu ul')[0];
    var scroll = menu.scrollTopMax;
    $(menu).animate({ scrollTop: scroll }, '300');
};

self.parseGetParams = function () {
    var $_GET = {};
    var __GET = window.location.search.substring(1).split("&");
    for (var i = 0; i < __GET.length; i++) {
        var getVar = __GET[i].split("=");
        $_GET[getVar[0]] = typeof getVar[1] == "undefined" ? "" : getVar[1];
    }
    return $_GET;
};

self.on('mount', function () {
    var params = self.parseGetParams();
    if (params.project && params.login && params.password) {
        localStorage.removeItem('shop24_cookie');
        app.login({
            project: params.project.trim(),
            serial: params.login.trim(),
            password: md5(params.password.trim()),
            success: function success(response, secookie) {
                var mainUser = {
                    project: params.project.trim(),
                    login: params.login.trim(),
                    hash: md5(params.password.trim())
                };

                localStorage.setItem('shop24_main_user', (0, _stringify2.default)(mainUser));
                localStorage.setItem('shop24_cookie', secookie);
                localStorage.setItem('shop24', (0, _stringify2.default)(response.config));
                if (response.permissions) localStorage.setItem('shop24_permissions', (0, _stringify2.default)(response.permissions));
                location.search = '';
                window.location.hash = '#orders/new';
            }
        });
        return;
    }

    if (localStorage.getItem('shop24_cookie') !== null) {
        API.authCheck({
            success: function success(response) {
                if (response.permissions) localStorage.setItem('shop24_permissions', (0, _stringify2.default)(response.permissions));

                app.init();
                riot.route.start(true);
            },
            error: function error(response, xhr) {
                // ✅ если реально 401 — принудительно показываем логин
                if (xhr && xhr.status === 401) {
                    localStorage.removeItem('shop24');
                    localStorage.removeItem('shop24_permissions');
                    localStorage.removeItem('shop24_cookie');
                    localStorage.removeItem('shop24_user');
                    localStorage.removeItem('shop24_main_user');

                    app.auth = false;
                    observable.trigger('auth', false);
                    riot.route.start(true);
                    return;
                }

                // иначе оставляем старую логику (восстановление/инициализация)
                var user = localStorage.getItem('shop24_user');
                if (user) {
                    app.restoreSession(user);
                } else {
                    app.init();
                    riot.route.start(true);
                }
            }
        });
    } else {
        app.init();
        riot.route.start(true);
    }

    window.addEventListener('resize', self.onResize);

    self.on('unmount', function () {
        window.removeEventListener('resize', self.onResize);
    });
});
});


// WEBPACK FOOTER //
// ./app.tag